// extracted by mini-css-extract-plugin
export default {"timerWrapper":"Timer_timerWrapper__T2yMP","clockSvg":"Timer_clockSvg__kdvXU","digitalText":"Timer_digitalText__AOVcS"};